import { render, staticRenderFns } from "./PermissionViewPermissionTimelineCard.vue?vue&type=template&id=6cc08e30&"
import script from "./PermissionViewPermissionTimelineCard.vue?vue&type=script&lang=js&"
export * from "./PermissionViewPermissionTimelineCard.vue?vue&type=script&lang=js&"
import style0 from "./PermissionViewPermissionTimelineCard.vue?vue&type=style&index=0&id=6cc08e30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports